import React from "react";

import GroupIcon from "@mui/icons-material/Group";
import AutoAwesomeMosaicIcon from "@mui/icons-material/AutoAwesomeMosaic";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import ModelTrainingIcon from "@mui/icons-material/ModelTraining";

const data = [
  {
    name: "Access Control",
    id: "access",
    icon: (color: any) => (
      <AssignmentIndIcon
        color={color}
        sx={{
          mr: 1.2,
        }}
      />
    ),
  },
  // {
  //   name: "Dashboard",
  //   id: "dashboard",
  //   icon: (color: any) => (
  //     <AutoAwesomeMosaicIcon
  //       color={color}
  //       sx={{
  //         mr: 1.2,
  //       }}
  //     />
  //   ),
  // },
  // {
  //   name: "Models",
  //   id: "model",
  //   icon: (color: any) => (
  //     <ModelTrainingIcon
  //       color={color}
  //       sx={{
  //         mr: 1.2,
  //       }}
  //     />
  //   ),
  // },
  // {
  //   name: "Requests",
  //   id: "requests",
  //   icon: (color: any) => (
  //     <AutorenewIcon
  //       color={color}
  //       sx={{
  //         mr: 1.2,
  //       }}
  //     />
  //   ),
  // },
  // {
  //   testid: "users",
  //   name: "Users",
  //   id: "users",
  //   icon: (color: any) => (
  //     <GroupIcon
  //       color={color}
  //       sx={{
  //         mr: 1.2,
  //       }}
  //     />
  //   ),
  // },
];

export default data;
